import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import { MainHeader } from "./MainHeader";
import { MainSidebar } from "./MainSidebar";
import { MainFooter } from "./MainFooter";
import { useWindowSize } from "@hooks/useWindowSize";
import { SIDEBAR_MODE, SIDEBAR_STATUS } from "@constants";
import styles from "./styles/MainLayout.module.css";
import { ToastContainer } from "react-toastify";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { sidebarActions } from "@redux/actions";

const MainLayout = ({ sidebarMode }) => {
  // state
  const { data } = useSelector((state) => state.layout.sidebar);
  const { status: sidebarStatus } = data;
  // const [sidebarStatus, handleChangeSidebar] = useState(SIDEBAR_STATUS.FULL);
  const dispatch = useDispatch();

  const handleChangeSidebar = (newStatus) => {
    dispatch(sidebarActions.updateStatus(newStatus));
  };

  // variables

  // const sidebarStatus

  // logics before hooks

  // hooks
  const { width } = useWindowSize();

  // logics

  const toggleSidebar = () => {
    if (sidebarStatus === SIDEBAR_STATUS.FULL) {
      if (width > 1024) {
        handleChangeSidebar(SIDEBAR_STATUS.MINI);
      } else {
        handleChangeSidebar(SIDEBAR_STATUS.HIDE);
      }
    } else {
      handleChangeSidebar(SIDEBAR_STATUS.FULL);
    }
  };

  // UI partials

  // effects
  useLayoutEffect(() => {
    if (width > 1024) {
      if (sidebarStatus === SIDEBAR_STATUS.MINI) return;
      handleChangeSidebar(SIDEBAR_STATUS.FULL);
    } else if (width !== 0) {
      handleChangeSidebar(SIDEBAR_STATUS.HIDE);
    }
  }, [width]);

  // render
  return (
    <div className={styles.mainLayoutContainer}>
      <ToastContainer className={styles.toastContainer} />
      <MainHeader toggleMenu={toggleSidebar} />
      <MainSidebar
        status={sidebarStatus}
        mode={sidebarMode}
        onChangeSidebar={handleChangeSidebar}
      />
      <div
        className={clsx(
          "d-flex flex-column justify-content-between",
          styles.reponsiveWrapper,
          sidebarStatus === SIDEBAR_STATUS.MINI && styles.wrapperWithMiniSidebar
        )}
      >
        <div className="p-0 flex-grow-1">
          <Outlet />
        </div>
        <MainFooter />
      </div>
    </div>
  );
};

/* required: display name */
MainLayout.displayName = "MainLayout";

/* required: props types */
MainLayout.propTypes = {
  sidebarMode: PropTypes.oneOf([
    SIDEBAR_MODE.DEFAULT,
    SIDEBAR_MODE.DASHBOARD,
    SIDEBAR_MODE.ADMIN,
  ]),
};

/* required: default props */
MainLayout.defaultProps = { sidebarMode: SIDEBAR_MODE.DEFAULT };

export { MainLayout };
